import React from 'react';
import { SvgProps } from '../../../models/components/svg';

const BlueInfoIcon: React.FC<SvgProps> = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        className={className}
    >
        <path
            d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM7.5 10.5674V11.5H8.5V10.5674H7.5ZM7.5 9.63379H8.5V4.5H7.5V9.63379Z"
            fill="#55ADED"
        />
    </svg>
);

export default BlueInfoIcon;
